(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('upsell-random')) {
    class UpsellRandom extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-upsell-item]'));
        this.count = parseInt(this.dataset.count, 10) || 4;
        this.hideEmpty = this.dataset.hideEmpty === 'true';
        this.cartIds = new Set(
          (this.dataset.cartIds || '').split(',').filter(Boolean).map(String)
        );

        // Premier rendu instantané avec le panier connu côté Liquid
        this.render({ reshuffle: true });

        // Mise à jour live à chaque modification du panier (ajout, suppression, quantité)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.scheduleRefresh());
        }

        const shuffleBtn = this.querySelector('[data-upsell-shuffle]');
        if (shuffleBtn) {
          shuffleBtn.addEventListener('click', () => this.render({ reshuffle: true }));
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        clearTimeout(this.refreshTimer);
      }

      scheduleRefresh() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refreshFromCart(), 250);
      }

      async refreshFromCart() {
        try {
          const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
          const cart = await response.json();
          this.cartIds = new Set(cart.items.map((i) => String(i.product_id)));
          this.render({ reshuffle: false });
        } catch (e) {
          console.error('[upsell-random] Impossible de lire le panier', e);
        }
      }

      shuffle(array) {
        const a = array.slice();
        for (let i = a.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
      }

      render({ reshuffle }) {
        const eligible = this.items.filter((el) => !this.cartIds.has(el.dataset.productId));

        // Sans reshuffle : on garde les cartes encore valides et on complète les trous
        let selection = reshuffle
          ? []
          : eligible.filter((el) => !el.hidden).slice(0, this.count);

        const remaining = this.shuffle(eligible.filter((el) => !selection.includes(el)));
        selection = selection.concat(remaining.slice(0, this.count - selection.length));

        this.items.forEach((el) => {
          const show = selection.includes(el);
          if (show && el.hidden) {
            el.hidden = false;
            el.classList.remove('is-entering');
            void el.offsetWidth;
            el.classList.add('is-entering');
          } else if (!show) {
            el.hidden = true;
          }
        });

        // Ordre d'affichage aléatoire dans la grille
        const list = this.querySelector('ul');
        if (list && reshuffle) selection.forEach((el) => list.appendChild(el));

        if (this.hideEmpty && !window.Shopify?.designMode) {
          this.hidden = selection.length === 0;
        }
      }
    }

    customElements.define('upsell-random', UpsellRandom);
  }

  } catch(e) { console.error(e); }
})();
})();
